import { pt } from "@ews/react-translations";
import { IonButton, IonIcon, IonInput, IonItem } from "@ionic/react";
import { closeSharp } from "ionicons/icons";
import { FC, useEffect, useState } from "react";

type MonthPickerProps = {
    value?: Date | string | null;
    slot?: string;
    onChange?: (value: string | null) => void;
};

const MonthPicker: FC<MonthPickerProps> = ({
    value = null,
    slot = 'start',
    onChange
}) =>
{

    value = typeof value === 'string' ? new Date(value) : value;
    const [_month, _year] = value ? [value.getMonth() + 1, value.getFullYear()] : [undefined, undefined];

    const [month, setMonth] = useState(_month);
    const [year, setYear] = useState(_year);

    const getValue = () =>
    {
        if (year && month) return `${`${year}`.padStart(4, '2000')}-${`${month}`.padStart(2, '0')}`;
        return null;
    };

    const rotateMonth = (month: number, year?: number) =>
    {
        year = year || (new Date()).getFullYear();
        if (month > 12) return [1, year + 1];
        if (month <= 0) return [12, year - 1];
        return [month, year];
    };

    const prefixYear = (year: number) =>
    {
        return parseInt(`${year}`.padStart(4, '2000'));
    };

    useEffect(() =>
    {
        if (onChange) onChange(getValue());
    });

    return (
        <IonItem
            slot={slot}
            lines="none"
        >
            <IonInput
                type='tel'
                value={month ? `${month}`.padStart(2, '0') : month}
                onFocus={(e) => (e.target as unknown as HTMLInputElement).select()}
                onKeyUp={({ key }) =>
                {
                    if (['ArrowUp', 'ArrowDown'].includes(key)) {

                        const add = key === 'ArrowUp' ? 1 : -1;
                        const [m, y] = rotateMonth((month || 0) + add, year);

                        setMonth(m);
                        setYear(y);
                    }
                }}
                onIonChange={({ detail: { value } }) =>
                {
                    setMonth(value ? rotateMonth(parseInt(value))[0] : undefined);
                }}
                style={{ textAlign: 'right', width: "20px" }}
                placeholder="__"
            ></IonInput>
            /
            <IonInput
                type='tel'
                value={year ? `${year}`.padStart(4, '2000') : year}
                onFocus={(e) => (e.target as unknown as HTMLInputElement).select()}
                onKeyUp={({ key }) =>
                {
                    if (key === 'ArrowUp') {
                        setYear((year || 0) + 1);
                    } else if (key === 'ArrowDown') {
                        setYear((year || 0) - 1);
                    }
                }}
                onIonChange={({ detail: { value } }) =>
                {
                    setYear(value ? prefixYear(parseInt(value)) : undefined);
                }}
                style={{ width: "40px" }}
                placeholder="____"
            ></IonInput>
            <IonButton onClick={(e) =>
            {
                setMonth(undefined);
                setYear(undefined);
            }}>
                <IonIcon icon={closeSharp} />
            </IonButton>
        </IonItem >
    );

};

export default MonthPicker;
